import { Link, Route, Routes, useFetcher, useLocation, useNavigate } from 'react-router-dom';
import './navbar.css';
import { useEffect, useState } from 'react';
import { useTypewriter, Cursor} from 'react-simple-typewriter';
import useInterval from '../interval/useInterval';
import { getPageVisit, changePageVisit, getDirArray,pushDirArray, removeDirArray, setPageload, getPageload } from '../pagevisit/pagevisit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpLong } from '@fortawesome/free-solid-svg-icons';
function Navbar(props){
        const [linkState, setLinkState] = useState(false);
        const [isBlinking, setIsBlinking] = useState(true);
        const [othersClicked, setOthersClicked] = useState(false);
        const [isHannah, setIsHannah] = useState(false);
        const [preloadBlackScreen, setPreloadBlackScreen] = useState(true);
        const [pageVisitCounter, setPageVisitCounter] = useState(false);
        const [currentDirectory, setCurrentDirectory] = useState('');
        const [dirstate, setDirState] = useState(false);
        const [devTools, setDevtools] = useState(false);
        const navigate = useNavigate();
        const [sameLocation, setSameLocation] = useState(false);
        const location = useLocation();
        useEffect(()=>{
            let string = '';
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Backspace'){
                    string = '';
                } else {
                    string += e.key;
                }
                if (string.includes('devtools')){
                    setDevtools(true);
                    string = '';
                }
                console.log(string);
                
            });
        },[]);
        const pages = {
            "home":{
                afterlinkstate: 1750,
                closed: false,
            },
            "projects":{
                afterlinkstate: 2100,
                isClosed: false,
            },
            "contacts":{
                afterlinkstate: 2150,
                isClosed: false,
            },
            "oldvers":{
                afterlinkstate: 2100,
                isClosed: false,
            },
            "editorexe":{
                afterlinkstate: 2000,
                isClosed: false,
            },
            "unknown":{
                afterlinkstate: 1000,
                isClosed: false,
            },
            "forhannahexe":{
                afterlinkstate: 2300,
                isClosed: false,
            },
            "gabby":{
                afterlinkstate: 1000,
                isClosed: true,
            },


        };
        useEffect(()=>{
            setCurrentDirectory(getDirArray()[getDirArray().length - 1]);

            // setDirectories(directories => [...directories, location.pathname]); 
            pushDirArray(props.page);
            // console.log(getPageVisit());
            // console.log(getDirArray()[0])
            // console.log(getDirArray(), getDirArray().length);
            // console.log(getDirArray().length);
            // console.log(dirCounter);
            // setCurrentDirectory(getDirArray()[getPageVisit()]);
            
            // console.log(location.pathname)
            // setCurrentDirectory(getDirArray()[getDirArray().length]);  
            // setCurrentDirectory(toString(getDirArray()[getDirArray().length - 1]));
            // console.log(currentDirectory);
            // console.log('array', getDirArray().length, getDirArray(), getDirArray()[getDirArray().length - 2]);
            
        },[Navbar]);
        
        useEffect(()=>{
            if(props.page === 'forhannah.exe'){
                setIsHannah(true);
            }
        });
    useInterval(() => {
        if (isBlinking == true) {
            // console.log('blink');
            setIsBlinking(false);
        } else if (isBlinking == false) {
            setIsBlinking(true);
            // console.log('noblink');
        }
    }, 500)
        useEffect(()=>{
            if (pageVisitCounter){
                setTimeout(()=>{
                    setLinkState(true);
                    setDirState(true);       
                }, props.linkstate);
            } else {
                setTimeout(() => {
                    setLinkState(true);
                    setDirState(true);
                    
                    setCurrentDirectory(getDirArray()[getDirArray().length - 1]);
                    
                }, !pages[`${props.page.replace('.', '')}`] ? (getPageVisit() > 1 ? 2000 : 3000) : (getPageVisit() < 1 ? props.linkstate : pages[`${props.page.replace('.','')}`].afterlinkstate));
            }
            
        },[]);

        useEffect(()=>{
            // console.log(pages[`${props.page.replace('.', '')}`].afterlinkstate);  
        },[])

        useEffect(()=>{
        
            setTimeout(()=>{
                setIsBlinking(false);
                // setCurrentDirectory((getDirArray()[getDirArray().length]));     
            },2300);
        }, [])
        
        useEffect(()=>{
            document.title = `${props.page} | stepwebdev.me`;
        },[]);

        const others = () => {
            if (othersClicked) {
                setOthersClicked(false);
            } else {
                setOthersClicked(true);
            }

        }
        // const interval = () => {
        //     setInterval(() => {
          
        //         // console.log('second')
        //     }, 1000);
        // }
        setTimeout(()=>{
            setPreloadBlackScreen(false);
        }, props.linkstate - 50);
        
        
        const [text] = useTypewriter({
            //! The "","","","","","","","","", is needed, its a delay before typing.
            words: pageVisitCounter ? ["", "", `${props.page == "confess.exe" ? 'bash confess.exe' : props.page == "editor.exe" ? "editor.exe" : `cd ${props.page}`}`, "", ""] : ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", `${props.page == "confess.exe" ? 'bash confess.exe' : props.page == "editor.exe" ? "editor.exe" : `cd ${props.page}`}`, ''],
            loop: 1,
            delaySpeed: 100,
            typeSpeed: 100,
            deleteSpeed: 0,
            // afterLoop: () => {
            //     console.log()
            // }
            
        });
        
        useEffect (()=>{
            changePageVisit(1);
            
            if (getPageVisit() > 1){
                setPageVisitCounter(true);
                setLinkState(true);
            }
        },[]);
        const navigateTo = (page) =>{
            setPageload(true);
            const time = 430;
                if (page === location.pathname) {
                    setPageload(false);
                    setSameLocation(true);
                    setTimeout(()=>{
                        setSameLocation(false);
                    }, 3000);
                    return;
                } else{
                    setSameLocation(false);
                    setTimeout(() => {
                        navigate(page);
                        setPageload(false);
                    }, time);
                }
        
            if (page === location.pathname){
                return;
            } else {
                
            }
            
        };
    return (
        <>
            
            <div className={`bg_samelocation ${sameLocation ? "true":"false"}`}>
            </div>
            <div className='devtools' style={{display:`${devTools ? "" : "none"}`}}>
            <h2 className="" style={{ position: "fixed", top: "60px", right: "30px", color:"white", fontSize:"15px", zIndex:"9999999"}}>Developer Options</h2>
            <button style={{ position: "fixed", top: "100px", right: "20px", zIndex: "1000" }} onClick={() => {
                
                navigateTo('/home');
                setTimeout(() =>{
                    navigateTo('/hannah');
                }, 2530)

            }}>Development Refresh (navigate)</button>
            <button style={{ position: "fixed", top: "125px", right: "20px", zIndex: "1000" }} onClick={() => {
                window.location.reload()
            }}>Location.Reload Refresh</button>
            </div>

            {/* <button onClick ={()=>{navigateTo('/gabby')}}>Home</button> */}
            <div className={`navbar ${pageVisitCounter ? "couplevisittimes" : ""} ${preloadBlackScreen ? "full" : "empty"}`} style={{}}>
                <div className={`rootsh ${linkState ? "" : "preload"} ${isHannah ? "hannah" : ""} ${sameLocation ? "sameloc" : ""}`}>
                    <h2><span style={{ color: "rgba(255,65,0,0.85)" }}>root</span><span style={{ color: "cyan" }}>@</span><span style={{ color: "rgba(255,220,0,1)" }}>Stephen</span>
                    <span className={`sameloc ${sameLocation ? 'true' : 'false'}`}>(/{currentDirectory})
                        {
                        sameLocation && 
                        (<div className="arrow">
                        <FontAwesomeIcon icon={faArrowUpLong}/>
                        </div>)
                    }
                    </span>:<span className='typewritter'>{text}</span><span className={`${isBlinking ? 'blinking' : 'noblinking'}`} style={{ fontSize: "21px" }}>▌</span></h2>
                </div>
                {linkState && (
                    <div className={`links ${pageVisitCounter ? " couplevisittimes" : ""}`} id='links'>
                        <p onClick={() => { navigateTo('/') }} className='link'>Home</p>
                        <p onClick={() => { navigateTo('/projects') }} className='link'>Projects</p>
                        <p onClick={() => { navigateTo('/contacts') }} className='link'>Contacts</p>
                        <p onClick={() => { navigateTo('/olderportofolio') }} className='link oldport'>Old Portfolios</p>
                        <p onClick={() => { navigateTo('/code_editor') }} className='link special code'>Code Editor</p>
                        <p onClick={() => { navigateTo('/unknown') }}  to='/unknown' className='link unknown' style={{}}>???</p>
                        <p className={`link ${!othersClicked ? 'special' : ''}`} id='others' onClick={()=> others()}>Others</p>
                    </div>
                )}  
            </div>

            {
                linkState && <>
            <div className={`dropdown ${othersClicked ? 'open' : 'close'}`}>
                <h2>Other links:</h2>
                <div className="row">
                    <p onClick={() => { navigateTo('/olderportofolio'); setOthersClicked(false); }} className='link oldport row'>Old Portfolios</p>
                    <p onClick={() => { navigateTo('/code_editor'); setOthersClicked(false); }} className='link special code row'>Code Editor</p>
                    <p onClick={() => { navigateTo('/unknown'); setOthersClicked(false); }} className='link' style={{color:'red'}}>???</p>
                    {/* <Link to='/' className='link'>Reserved Links</Link> */}
                    
                </div>
            </div>

                </>
            }
        </>
    );
}
export default Navbar;